export const AXIOS_NAMES = {
    SELF: "SELF",
    ONEMIN: "onemin",
    DEFAULT: "basic"
};
